document.addEventListener('DOMContentLoaded', function() {
    var productGrids = document.querySelectorAll('.custom_swatch_class');
console.log('productGrids',productGrids)
    productGrids.forEach(function(productGrid) {
      console.log('productGrid',productGrid)
      var sectionId = productGrid.getAttribute('data-section-id');
      console.log('sectionId',sectionId)
      var variantDataMap = window['variantDataMap' + sectionId.replace(/-/g, '_')];
      console.log('variantDataMap',variantDataMap)
      productGrid.addEventListener('change', function(e) {
         console.log('onchange event work')
          if (e.target.matches('input[type="radio"][data-section-id="' + sectionId + '"]')) {
  console.log('e.target.matches')
            console.log('e.target.closest',e.target)
            console.log(`.card-product-custom-div[data-section-id="${sectionId}"]`)
              var card = e.target.closest(`.card-product-custom-div[data-section-id="${sectionId}"]`);
            console.log('card',card)
              var variantId = e.target.getAttribute('data-variant-id');
            console.log('variantId',variantId)
              var variantData = variantDataMap[variantId];
  console.log('variantData',variantData)
              if (!variantData) {
                  console.log('No data found for variant:', variantId);
                  return;
              }
  
              // Update the product image with lazy loading logic
              var productImageElement = card.querySelector('.grid-view-item__image-wrapper img');
              if (productImageElement) {
                  var lazyLoadAllVariants = card.getAttribute('data-lazy-load-all-variants') === 'true';
                  if (lazyLoadAllVariants) {
                      var preloadedImage = card.querySelector(`img[data-variant-id="${variantId}"]`);
                      if (preloadedImage) {
                          productImageElement.src = preloadedImage.src;
                          productImageElement.srcset = preloadedImage.srcset;
                        console.log('preloadedImage',preloadedImage)
                      } else {
                          console.log('Matching preloaded image not found for variant:', variantId);
                      }
                  } else {
                      // Update src and srcset for responsive images
                      var dynamicSrcset = [
                          variantData.imageUrl + '?width=165 165w',
                          variantData.imageUrl + '?width=360 360w',
                          variantData.imageUrl + '?width=533 533w',
                          variantData.imageUrl + '?width=720 720w',
                          variantData.imageUrl + '?width=940 940w',
                          variantData.imageUrl + '?width=1066 1066w'
                      ].join(', ');
                      productImageElement.srcset = dynamicSrcset;
                      productImageElement.src = variantData.imageUrl;
                      console.log('Update src and srcset for responsive images')
                  }
              } else {
                  console.log('No product image element found in this card.');
              }
  
              // Update the product URL
              var productLinks = card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
              productLinks.forEach(function(link) {
                  link.href = variantData.productUrl;
              });
  
          } else {
              console.log('Change detected, but not on a swatch.');
          }
      });
    });
});